import { apiRequest } from './client';
import type { CycleProcedure, CycleProcedureStatus } from '../types/admin';

export type CreateProcedurePayload = {
  readonly title: string;
  readonly description?: string | null;
  readonly is_required?: boolean;
  readonly procedure_template_id?: string | null;
  readonly sort_order?: number;
};

export type UpdateProcedurePayload = {
  readonly title?: string;
  readonly description?: string | null;
  readonly status?: CycleProcedureStatus;
  readonly is_required?: boolean;
  readonly sort_order?: number;
};

export function listCycleProcedures(
  patientId: string,
  treatmentId: string,
  cycleId: string,
  accessToken: string,
): Promise<readonly CycleProcedure[]> {
  return apiRequest<readonly CycleProcedure[]>(
    `/admin/patients/${patientId}/treatments/${treatmentId}/cycles/${cycleId}/procedures`,
    { token: accessToken },
  );
}

export function createCycleProcedure(
  patientId: string,
  treatmentId: string,
  cycleId: string,
  payload: CreateProcedurePayload,
  accessToken: string,
): Promise<CycleProcedure> {
  return apiRequest<CycleProcedure>(
    `/admin/patients/${patientId}/treatments/${treatmentId}/cycles/${cycleId}/procedures`,
    { method: 'POST', body: payload, token: accessToken },
  );
}

export function updateCycleProcedure(
  patientId: string,
  treatmentId: string,
  cycleId: string,
  procedureId: string,
  payload: UpdateProcedurePayload,
  accessToken: string,
): Promise<CycleProcedure> {
  return apiRequest<CycleProcedure>(
    `/admin/patients/${patientId}/treatments/${treatmentId}/cycles/${cycleId}/procedures/${procedureId}`,
    { method: 'PATCH', body: payload, token: accessToken },
  );
}

export function deleteCycleProcedure(
  patientId: string,
  treatmentId: string,
  cycleId: string,
  procedureId: string,
  accessToken: string,
): Promise<void> {
  return apiRequest<void>(
    `/admin/patients/${patientId}/treatments/${treatmentId}/cycles/${cycleId}/procedures/${procedureId}`,
    { method: 'DELETE', token: accessToken },
  );
}

export function reorderCycleProcedures(
  patientId: string,
  treatmentId: string,
  cycleId: string,
  orderedProcedureIds: readonly string[],
  accessToken: string,
): Promise<readonly CycleProcedure[]> {
  return Promise.all(
    orderedProcedureIds.map((procedureId, index) =>
      updateCycleProcedure(
        patientId,
        treatmentId,
        cycleId,
        procedureId,
        { sort_order: index },
        accessToken,
      ),
    ),
  );
}
